<template>
  <section v-if="error">
    <br/>
    <p class="error">{{ error }}</p>
  </section>

 <section class="grid-container" v-if="!error && loaded && task && task.taskStatus !== TASK_STATUS.SUCCESSFULLY_COMPLETED.value">
    <div>
      <br/>
        <WizardProgress :currentStep="stepIndex + 1" :totalSteps="steps.length" />
    </div>
    <div class="page-container grid-container wizard">
      <div class="grid-x grid-margin-x" >
        <component v-if="loaded" :key="stepIndex" :is="currentStepComponent" @next="nextStep" @prev="prevStep" ref="stepComponentRef" :formData="formData" L  @update-form="handleFormUpdate"/>

        <div v-if="stepIndex < steps.length - 1" id="wizard-navigation" class="cell small-12">
          <button class="btn btn-secondary" @click="prevStep" v-if="stepIndex != 0" :disabled="isProcessing">Previous</button>
          <button class="btn btn-primary" @click="nextStep" :disabled="isProcessing || stepIndex === steps.length - 1">{{ isProcessing ? 'Please wait...' : 'Next' }}</button>
          <button class="btn btn-link" @click="finish" :disabled="isProcessing">Cancel</button>
        </div>

        <div class="cell small-12">
          <button class="btn btn-primary" @click="finish" v-if="stepIndex == steps.length - 1">Finish</button>
        </div>


      </div>
    </div>

  </section>

     <section class="page-container grid-container" v-else> 
    <div class="grid-x grid-margin-x">
        <div class="cell small-12">
            <a @click="router.back()">← Back</a>
        </div>
    </div>
    <br/>
    <div class="grid-x grid-margin-x">
        <div class="cell small-12">
            <h1 class="text-2xl font-bold">Auto Enrolment Questionnaire</h1>
            <p>Thank you for completing your auto enrolment questionnaire, it is currently being reviewed by our team.</p>
        
         <table v-if="questionnaireResponse">
            <thead>
              <tr>
                <th>Answers Summary</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Pension Provider Name</td>
                <td>{{ questionnaireResponse?.pensionProviderName }}</td>
              </tr>
              <tr>
                <td>Scheme Reference</td>
                <td>{{ questionnaireResponse?.schemeReference }}</td>
              </tr>
              <tr>
                <td>Pension scheme uses qualifying earnings</td>
                <td>{{ formatToYesNo(questionnaireResponse?.qualifyingEarningsBands) }}</td>
              </tr>
              <tr>
                <td>Salary Exchange (Salary Sacrifice) is in use</td>
                <td>{{ formatToYesNo(questionnaireResponse?.salaryExchange) }}</td>
              </tr>
              <tr v-if="questionnaireResponse?.salaryExchange">
                <td>Employee NI savings are reinvested into the pension scheme</td>
                <td>{{ formatToYesNo(questionnaireResponse?.eeReinvestment)  }}</td>
              </tr>
              <tr v-if="questionnaireResponse?.salaryExchange">
                <td>Employer NI savings are reinvested into the pension scheme</td>
                <td>{{ formatToYesNo(questionnaireResponse?.erReinvestment) }}</td>
              </tr>
              <tr>
                <td>Tax Relief Type</td>
                <td>{{ questionnaireResponse?.taxRelief }}</td>
              </tr>
              <tr>
                <td>Postpone Eligible Employees</td>
                <td>{{ formatToYesNo(questionnaireResponse?.applyPostponement) }}</td>
              </tr>
            </tbody>
          </table>
          <div class="section">
          <br/>
          <h4>Auto Enrolment (AE) Groups</h4>
          <table v-if="questionnaireResponse?.aeGroups.length > 0">
            <thead>
              <tr>
                <th>Group Name</th>
                <th>Employee Percentage</th>
                <th>Employer Percentage</th>
                <th>Qualifying Earnings</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(group, index) in questionnaireResponse?.aeGroups" :key="index">
                <td>{{ group.aegroup }}</td>
                <td>{{ group.eePerc }}%</td>
                <td>{{ group.erPerc }}%</td>
                <td>{{ formatToYesNo(group.qualifyingEarnings) }}</td>
              </tr>
           
            </tbody>
          </table>
          </div>
                    <div class="section">
          <br/>
          <h4>Payment Sources</h4>
          <table v-if="questionnaireResponse?.paymentSources.length > 0">
            <thead>
              <tr>
                <th>Payment Source Name</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(paymentsource, index) in questionnaireResponse?.paymentSources" :key="index">
                <td>{{ paymentsource.paymentSourceName }}</td>

              </tr>
           
            </tbody>
          </table>
          </div>
          <button class="btn btn-secondary" @click="router.back()">Return to Tasks</button>
          </div>
    </div>
  </section>
</template>


<script setup>

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import WizardProgress from '@/components/navigation/WizardProgressBar.vue';
import Step1 from './AutoEnrolment-Questionnaire-Step1.vue'
import Step2 from './AutoEnrolment-Questionnaire-Step2.vue'
import Step3 from './AutoEnrolment-Questionnaire-Step3.vue'
import Step4 from './AutoEnrolment-Questionnaire-Step4.vue'
import Step5 from './AutoEnrolment-Questionnaire-Step5.vue'
import Step6 from './AutoEnrolment-Questionnaire-Step6.vue'
import Step7 from './AutoEnrolment-Questionnaire-Step7.vue'
import Step8 from './AutoEnrolment-Questionnaire-Step8.vue'
import Step9 from './AutoEnrolment-Questionnaire-Step9.vue'
import { TASK_STATUS } from '@/helpers/constants';

import { formatToYesNo } from '@/helpers/boolean';

const steps = [
  { label: 'Getting Started', component: Step1 },
  { label: 'Pension Provider', component: Step2 },
  { label: 'Scheme Reference', component: Step3 },
  { label: 'Salary Exchange (Salary Sacrifice)', component: Step4 },
  { label: 'Tax Relief Method', component: Step5 },
  { label: 'Auto Enrolment (AE) Group', component: Step6 },
  { label: 'Payment Source', component: Step7 },
  { label: 'Postponement', component: Step8 },
  { label: 'Complete', component: Step9 },
];
const stepIndex = ref(0)

const loaded = ref(false);

const stepComponentRef = ref(null)
const isProcessing = ref(false)

const currentStepComponent = computed(() => steps[stepIndex.value].component)

const route = useRoute();
const router = useRouter();
const taskId = route.params.taskId;
const task = ref(null);
const questionnaireResponse = ref(null);

import { getDataCollectionTask } from '@/services/implementationmanagement.api';
onMounted(async () => {

  var response = await getDataCollectionTask(taskId);

  if(response.status !== 200 || response.data === null || response.data === undefined) {
    error.value = errorString;
    return null;
  }

  task.value = response.data;

   try {

    // If dataJson is empty string then set accoridingly, otherwise parse it
    if(!task.value.dataJson || task.value.dataJson.trim() === "") {
      questionnaireResponse.value = "";
      loaded.value = true;
      return;
    }

    questionnaireResponse.value = JSON.parse(task.value.dataJson);

    loaded.value = true;
  } catch (e) {
    error.value = "Failed to parse questionnaire data";
    return;
  }

});


const nextStep = async () => {
  if (isProcessing.value) return;

  isProcessing.value = true;

  try {
    if (stepComponentRef.value && typeof stepComponentRef.value.validateStep === 'function') {
      const isValid = stepComponentRef.value.validateStep();

      if (!isValid) {
        return;
      }
    }

    if (stepComponentRef.value && typeof stepComponentRef.value.executeStep === 'function') {
      const success = await stepComponentRef.value.executeStep();
      if (!success) return;
    }

    error.value = null; // clear previous errors

    if (stepIndex.value < steps.length - 1) {
      stepIndex.value++;
    }
  } finally {
    isProcessing.value = false;
  }
}

const prevStep = () => {
  if (isProcessing.value) return;

  if (stepIndex.value > 0) {
    stepIndex.value--
  }
}



const finish = () => {
  if (isProcessing.value) return;

  router.back()
}

const error = ref(null)


const formData = ref({
  "aeGroups": [],
  "paymentSources": []
});
const handleFormUpdate = (updatedData) => {
  formData.value = updatedData;
};


</script>


<style scoped>
#wizard-breadcrumbs {
  margin-bottom: 40px;
  margin-top: 40px;
}

#wizard-navigation
{
  margin-top:30px;
}

</style>